export const slug = "clients-list";
export const title = "Clients List";
export const section = "Core";
export const content = `
# Clients List

The Clients page is the central directory of everyone registered with your food bank.

## Searching & Filtering

Use the **search bar** at the top to find a client by name, phone, or address. Results update as you type.

The **filter bar** below the search offers additional options:

- **Flagged** — show only clients whose records have been flagged for review (phone bounce, email bounce, address issue, etc.).
- **Visited This Week** — limit results to clients who have already been served this Saturday.
- **Coat Season** — highlights clients enrolled in the winter coat program.
- **Address Validation** — filter by whether the address has been verified, unverified, or flagged as invalid.

## Address Validation Badges

Each row may show a small badge next to the client's address:

- **Green checkmark** — address confirmed valid.
- **Yellow warning** — address has not been verified yet.
- **Red X** — address failed validation; staff should follow up before the next distribution.

## Bulk Operations

Select one or more rows using the checkboxes on the left, then choose an action from the **Bulk Actions** dropdown:

- **Verify Selected** — mark address as confirmed for all selected clients.
- **Clear Flags** — remove active flags from selected records.
- **Export as CSV** — download the selected clients' data as a spreadsheet.

## Coat-Season Indicator

When coat season is active, a coat icon appears on rows for clients enrolled in that program. Coat season is configured by an admin under **Settings → Seasonal Programs**.

## Opening a Client Record

Click any row to open the full client detail view. Changes made there are reflected immediately when you return to this list.
`;
